import { Injectable } from '@angular/core';
import { StateService } from './state.service';


@Injectable({
  providedIn: 'root'
})
export class RBACService {

  constructor(private stateService: StateService) { }

  isSuperAdmin() {
    return this.stateService.getCurrentUser().roles.includes('superadmin');
  }

  isInternal() {
    return this.stateService.getCurrentUser().roles.includes('internal');
  }
  
  isAdmin() {
    return this.stateService.getCurrentUser().roles.includes('admin');
  }

  /**
   * "Project-scoped admin": a superadmin, OR an admin whose company is the current
   * project's company. Mirrors the backend CASL rule that grants admins management
   * of their own company's resources only (NOT third-party projects they're invited
   * to). Used to gate destructive measurement ops (e.g. datapoint removal).
   */
  isProjectAdmin(): boolean {
    if (this.isSuperAdmin()) return true;
    if (!this.isAdmin()) return false;
    const project = this.stateService.getCurrentProject();
    const user = this.stateService.getCurrentUser();
    if (!project || !user) return false;
    return String((user as any).company) === String((project as any).company);
  }

  isUser() {
    return this.stateService.getCurrentUser().roles.includes('user');

  }

  canReadProject() {
    if (this.isSuperAdmin()) return true;
    const project = this.stateService.getCurrentProject();
    const uid = this.stateService.getCurrentUser()._id;

    return (
        project.owner === uid ||
        project.shared_w.includes(uid) ||
        project.shared_r.includes(uid)
    )
  }

  canEditProject() {
    if (this.isSuperAdmin()) return true;
    const project = this.stateService.getCurrentProject();
    const uid = this.stateService.getCurrentUser()._id;

    return (
        project.owner === uid ||
        project.shared_w.includes(uid)
    )
  }

  canManageProject() {
    if (this.isSuperAdmin()) return true;
    const project = this.stateService.getCurrentProject();
    const uid = this.stateService.getCurrentUser()._id;

    return project.owner === uid
  }


}
